import {createSlice, PayloadAction} from "@reduxjs/toolkit"
import {RootState} from "../../store/store"

const modulesSlice = createSlice({
    name: "modules",
    initialState: {
        menuList: [],
        addMapping: false,
        bulkActionsButton: false,
        sessionModuleReport: false,
        logReport: false,
        complaintAddButton: false,
        commentAddButton: false,
        priceModificationTab: false,
        powerRatingEdit: false,
        complaintReport: false,
        settlementSetup: false,
        tariffSetup: false,
        rateLimit: false,
    } as {
        menuList: null | [] | undefined
        addMapping: null | boolean | undefined
        bulkActionsButton: null | boolean | undefined
        sessionModuleReport: null | boolean | undefined
        logReport: null | boolean | undefined
        complaintAddButton: null | boolean | undefined
        commentAddButton: null | boolean | undefined
        priceModificationTab: null | boolean | undefined
        powerRatingEdit: null | boolean | undefined
        complaintReport: null | boolean | undefined
        settlementSetup: null | boolean | undefined
        tariffSetup: null | boolean | undefined
        rateLimit: null | boolean | undefined
    },
    reducers: {
        setMenuList: (state, {payload: {menuList}}: PayloadAction<{menuList: null | [] | undefined}>) => {
            state.menuList = menuList
        },
        setAddMapping: (state, {payload: {addMapping}}: PayloadAction<{addMapping: null | boolean | undefined}>) => {
            state.addMapping = addMapping
        },
        setBulkActionsButton: (
            state,
            {payload: {bulkActionsButton}}: PayloadAction<{bulkActionsButton: null | boolean | undefined}>
        ) => {
            state.bulkActionsButton = bulkActionsButton
        },
        setSessionModuleReport: (
            state,
            {payload: {sessionModuleReport}}: PayloadAction<{sessionModuleReport: null | boolean | undefined}>
        ) => {
            state.sessionModuleReport = sessionModuleReport
        },
        setLogReport: (state, {payload: {logReport}}: PayloadAction<{logReport: null | boolean | undefined}>) => {
            state.logReport = logReport
        },
        setComplaintAdd: (
            state,
            {payload: {complaintAddButton}}: PayloadAction<{complaintAddButton: null | boolean | undefined}>
        ) => {
            state.complaintAddButton = complaintAddButton
        },
        setCommentAdd: (
            state,
            {payload: {commentAddButton}}: PayloadAction<{commentAddButton: null | boolean | undefined}>
        ) => {
            state.commentAddButton = commentAddButton
        },
        setPriceModification: (
            state,
            {payload: {priceModificationTab}}: PayloadAction<{priceModificationTab: null | boolean | undefined}>
        ) => {
            state.priceModificationTab = priceModificationTab
        },
        setPowerRatingEdit: (
            state,
            {payload: {powerRatingEdit}}: PayloadAction<{powerRatingEdit: null | boolean | undefined}>
        ) => {
            state.powerRatingEdit = powerRatingEdit
        },
        setComplaintReport: (
            state,
            {payload: {complaintReport}}: PayloadAction<{complaintReport: null | boolean | undefined}>
        ) => {
            state.complaintReport = complaintReport
        },
        setSettlementSetup: (
            state,
            {payload: {settlementSetup}}: PayloadAction<{settlementSetup: null | boolean | undefined}>
        ) => {
            state.settlementSetup = settlementSetup
        },
        setTariffSetup: (state, {payload: {tariffSetup}}: PayloadAction<{tariffSetup: null | boolean | undefined}>) => {
            state.tariffSetup = tariffSetup
        },
        setRateLimit: (state, {payload: {rateLimit}}: PayloadAction<{rateLimit: null | boolean | undefined}>) => {
            state.rateLimit = rateLimit
        },
    },
})

export const {
    setMenuList,
    setAddMapping,
    setBulkActionsButton,
    setSessionModuleReport,
    setLogReport,
    setComplaintAdd,
    setCommentAdd,
    setPriceModification,
    setPowerRatingEdit,
    setComplaintReport,
    setSettlementSetup,
    setTariffSetup,
    setRateLimit,
} = modulesSlice.actions

export default modulesSlice.reducer

export const getMenuList = (state: RootState) => state.modules.menuList
export const getAddMapping = (state: RootState) => state.modules.addMapping
export const getBulkActionsButton = (state: RootState) => state.modules.bulkActionsButton
export const getSessionModuleReport = (state: RootState) => state.modules.sessionModuleReport
export const getLogReport = (state: RootState) => state.modules.logReport
export const getComplaintAddButton = (state: RootState) => state.modules.complaintAddButton
export const getCommentAddButton = (state: RootState) => state.modules.commentAddButton
export const getPriceModificationTab = (state: RootState) => state.modules.priceModificationTab
export const getPowerRatingEdit = (state: RootState) => state.modules.powerRatingEdit
export const getComplaintReport = (state: RootState) => state.modules.complaintReport
export const getSettlementSetup = (state: RootState) => state.modules.settlementSetup
export const getTariffSetup = (state: RootState) => state.modules.tariffSetup
export const getRateLimit = (state: RootState) => state.modules.rateLimit
